import groundcover from '@groundcover/browser';
export default groundcover;
